/**
 * AI CONTEXT
 * Purpose: a classroom media path is sometimes already a download URL.
 * The updates feed treats an https storagePath as finished. Jarvis players
 * must do the same instead of asking Storage for a path that is not a path.
 * Used by: useStandoutMediaUrl.
 */

/** An https storagePath is already playable. Anything else needs Storage. */
export const directStandoutMediaUrl = (
  storagePath: string | null | undefined
): string | null => {
  const trimmed = storagePath?.trim()
  if (!trimmed || !trimmed.startsWith("https://")) return null
  return trimmed
}
